import { render, staticRenderFns } from "./HuskyCardModal.vue?vue&type=template&id=61077d5a&scoped=true&"
import script from "./HuskyCardModal.vue?vue&type=script&lang=js&"
export * from "./HuskyCardModal.vue?vue&type=script&lang=js&"
import style0 from "./HuskyCardModal.vue?vue&type=style&index=0&id=61077d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61077d5a",
  null
  
)

export default component.exports